<template>
  <div class="box-card">
      <h2>注意事项</h2>
      <p>1. 所付订单金额是扣除环保补助或者其他新机活动以后的价格，旧机回收线在完成交易后，打款到该用户</p>
      <p>2. 支付说明：旧机款项在您旧机到货和完成交易以后，速回收打款到您指定的付款账户</p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.box-card {
  position: relative;
  padding:0.14rem;
}
.box-card h2{
  font-size: 0.12rem;
}
.box-card p {
  font-size: 0.12rem;
  color: #999;
  margin-top: 0.1rem;
  line-height: 0.2rem;
}
</style>
